<div class="vip-banner" *ngIf="showVipBanner">
	<div class="vip-banner__inner">
		<div class="vip-banner__left">
			<mat-icon class="vip-banner__icon">notifications</mat-icon>
			<div class="vip-banner__text d-none d-lg-block">
				<div class="vip-banner__title">{{ upgradeType === 'vipPlus' ? locale.translations['payment']['n719'] : locale.translations['payment']['n720'] }}</div>
				<div class="vip-banner__subtitle">
					{{ upgradeType === 'vipPlus'
						? locale.translations['payment']['n721']
						: locale.translations['payment']['n722']
					}}
				</div>
			</div>

			<div class="vip-banner__text d-lg-none" >
				<div class="vip-banner__title">{{ upgradeType === 'vipPlus' ? locale.translations['payment']['724'] : locale.translations['payment']['723'] }}</div>
				<div class="vip-banner__subtitle">
					{{ upgradeType === 'vipPlus'
						? locale.translations['payment']['726']
						: locale.translations['payment']['725']
					}}
				</div>
			</div>

		</div>
		<div class="vip-banner__right">
			<button mat-flat-button color="primary" class="vip-banner__cta" (click)="onUpgrade()">
				{{ upgradeType === 'vipPlus' ? locale.translations['payment']['n709'] : locale.translations['payment']['n716'] }}
			</button>
		</div>
	</div>
</div>

<mat-toolbar
	[ngClass]="{ 'toolbar--with-banner': showVipBanner }"
	[ngStyle]="{
		padding: viewport.type === 'desktop' ? '24px' : '16px'
	}"
	[style.margin-bottom]="viewport.type === 'desktop' ? '24px' : '0px'"
>
	<a href="/" class="brand" id="n0">
		<img href="/" [src]="'assets/images/logos/kurdshopping.png'  | s3Image" class="logo" />

		<span *ngIf="viewport.type === 'desktop'">&nbsp;&nbsp;{{ locale.translations['header']['n0'] }}</span>
	</a>

	<ng-container *ngIf="viewport.showFooter || isWaAlertsRoute()">
		<span class="fill-space"></span>

		<a mat-button href="/" id="n107" [ngClass]="{ minify: viewport.type !== 'desktop' }">
			<mat-icon>home</mat-icon>

			<span *ngIf="viewport.type === 'desktop'">&nbsp;{{ locale.translations['header']['n107'] }}</span>
		</a>

		<button mat-button [matMenuTriggerFor]="languageMenu" id="n1" [ngClass]="{ minify: viewport.type !== 'desktop' }">
			<img [src]="'assets/images/flags/english.png' | s3Image" width="24" *ngIf="locale.lang === 'en'" />

			<img [src]="'assets/images/flags/kurdistan.png' | s3Image" width="24" *ngIf="locale.lang === 'ku'" />

			<img [src]="'assets/images/flags/iraq.png' | s3Image" width="24" *ngIf="locale.lang === 'ar'" />

			<span *ngIf="viewport.type === 'desktop'">&nbsp;&nbsp;{{ locale.translations['header']['n1'] }}</span>
		</button>

		<mat-menu #languageMenu="matMenu">
			<button mat-menu-item (click)="onLanguageChange('en')" id="n2" [ngClass]="{ active: locale.lang === 'en' }">
				<img [src]="'assets/images/flags/english.png' | s3Image" height="24" />
				&nbsp;&nbsp;

				<span>{{ locale.translations['header']['n2'] }}</span>
			</button>

			<button mat-menu-item (click)="onLanguageChange('ku')" id="n3" [ngClass]="{ active: locale.lang === 'ku' }">
				<img [src]="'assets/images/flags/kurdistan.png' | s3Image" height="24" />
				&nbsp;&nbsp;

				<span>{{ locale.translations['header']['n3'] }}</span>
			</button>

			<button mat-menu-item (click)="onLanguageChange('ar')" id="n4" [ngClass]="{ active: locale.lang === 'ar' }">
				<img [src]="'assets/images/flags/iraq.png' | s3Image" height="24" />
				&nbsp;&nbsp;

				<span>{{ locale.translations['header']['n4'] }}</span>
			</button>
		</mat-menu>

		<ng-container *ngIf="!user; else notLoggedIn">
			<button *ngIf="auth.toggleHeaderLogin$ | async" mat-button class="n51 n56" [ngClass]="{ minify: viewport.type !== 'desktop' }" (click)="onLogin()">
				<mat-icon class="mat-icon-rtl-mirror">exit_to_app</mat-icon>

				<span *ngIf="viewport.type === 'desktop'">
					&nbsp;{{ locale.translations['logup']['login']['n51'] }} &#47; {{ locale.translations['logup']['signup']['n56'] }}
				</span>
			</button>
			<!-- <button mat-flat-button color="primary" id="n10" (click)="onDevice()">Device Detect</button> -->
		</ng-container>
		<!-- <ng-container *ngIf="!user; else notLoggedIn">
		<a mat-button [routerLink]="['/logup']" [queryParams]="{ lang: locale.lang }" class="n51 n56" [ngClass]="{'minify': viewport.type !== 'desktop'}"><mat-icon class="mat-icon-rtl-mirror">exit_to_app</mat-icon><span *ngIf="viewport.type === 'desktop'">&nbsp;{{ locale.translations['logup']['login']['n51']}} &#47; {{ locale.translations['logup']['signup']['n56']}}</span></a>
	</ng-container> -->

		<ng-template #notLoggedIn>
			<a mat-button [matMenuTriggerFor]="userMenu" [ngClass]="{ minify: viewport.type !== 'desktop' }">
				<mat-icon class="mat-icon-rtl-mirror">person</mat-icon>

				<span *ngIf="viewport.type === 'desktop'">&nbsp;{{ user['name'] | titlecase }}</span>
			</a>

			<mat-menu #userMenu="matMenu">
				<!-- <a mat-menu-item *ngIf="user['userType']==='1'" [routerLink]="['/dealer/' + user['userID'] + '/profile']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [queryParams]="{ lang: locale.lang }" id="n6"><mat-icon class="mat-icon-rtl-mirror">assignment</mat-icon><span>{{ locale.translations['header']['n6'] }} </span></a> -->
				<a
					mat-menu-item
					*ngIf="user['userType'] === '0'"
					[routerLink]="['/user/' + user['userID'] + '/profile']"
					routerLinkActive="active"
					[routerLinkActiveOptions]="{ exact: true }"
					id="n6"
				>
					<mat-icon class="mat-icon-rtl-mirror">assignment</mat-icon>

					<span>{{ locale.translations['header']['n6'] }}</span>
				</a>
				<a
					mat-menu-item
					[routerLink]="['/user/' + user['userID'] + '/ads']"
					routerLinkActive="active"
					[routerLinkActiveOptions]="{ exact: true }"
					id="n7"
				>
					<mat-icon class="mat-icon-rtl-mirror">view_carousel</mat-icon>

					<span>{{ locale.translations['header']['n7'] }}</span>
				</a>
				<a
					mat-menu-item
					[routerLink]="['/user/' + user['userID'] + '/ads']"
					routerLinkActive="active"
					[routerLinkActiveOptions]="{ exact: true }"
					[queryParams]="{ tab: 'watchlist' }"
					id="n8"
				>
					<mat-icon class="mat-icon-rtl-mirror">favorite</mat-icon>

					<span>{{ locale.translations['header']['n8'] }}</span>
				</a>

				<a
					mat-menu-item
					[routerLink]="['/user/wa-alerts']"
					routerLinkActive="active"
					[routerLinkActiveOptions]="{ exact: true }"
					id="test"
				>
					<mat-icon class="mat-icon-rtl-mirror">add_alert</mat-icon>

					<span>
						{{ locale.translations['header']['n11'] }}
					</span>
				</a>

				<mat-divider></mat-divider>

				<a mat-menu-item (click)="onLogout()" id="n9">
					<mat-icon class="mat-icon-rtl-mirror">power_settings_new</mat-icon>

					<span>{{ locale.translations['header']['n9'] }}</span>
				</a>
			</mat-menu>
		</ng-template>

		<a
			*ngIf="(!(placeAd.enablePlaceAdMobile$ | async) && viewport.type === 'mobile') || viewport.type === 'desktop'"
			[routerLink]="['/placead']"
			mat-flat-button
			color="primary"
			id="n10"
		>
			<mat-icon class="mat-icon-rtl-mirror">add_circle_outline</mat-icon>
			&nbsp;

			<span>{{ locale.translations['header']['n10'] }}</span>
		</a>

		&nbsp;
	</ng-container>
</mat-toolbar>
<a
	*ngIf="(placeAd.togglePlaceAdMobile$ | async) && viewport.type === 'mobile'"
	class="place-ad text-body-14px-medium"
	[routerLink]="['/placead']"
	mat-flat-button
	color="primary"
	id="n10"
>
	<mat-icon class="mat-icon-rtl-mirror">add_circle_outline</mat-icon>

	{{ locale.translations['header']['n10'] }}
</a>
